import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({


  state: {
    environmentSetting : 'DEV',

    isGAEvent : false,

    projectCount : 0,
    projectLoaded : 0,
    isShowLoading : true,
    viewingScreen : '',
    selectingIndex : 0,
    selectingVideo : '',
    contactEvent : false,


    isLoadingFinished : false,

  },
})




// WEBPACK FOOTER //
// ./src/store.js